import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet, themeGetColor } from 'modules/tetrisTheme';
const defaultStyle = css `
  color: ${themeGetColor('text.200')};
  background-color: ${themeGetColor('primary.50', 0.5)};
  border-color: ${themeGetColor('border.100')};

  [data-icon='falcon'] {
    color: ${themeGetColor('primary.400')};
  }

  &:disabled {
    background-color: ${themeGetColor('primary.50')};
    border-color: ${themeGetColor('primary.50')};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGetColor('primary.50')};
      border-color: ${themeGetColor('primary.200')};
    }

    &:active {
      background-color: ${themeGetColor('primary.100')};
      border-color: ${themeGetColor('primary.200')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
    }
  }
`;
const draftStyle = css `
  color: ${themeGetColor('blue.700')};
  background-color: ${themeGetColor('blue.50')};
  border-color: ${themeGetColor('blue.200')};

  [data-icon='falcon'] {
    color: ${themeGetColor('blue.600')};
  }

  &:disabled {
    background-color: ${themeGetColor('blue.50')};
    border-color: ${themeGetColor('blue.300')};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGetColor('blue.100')};
      border-color: ${themeGetColor('blue.300')};
    }

    &:active {
      background-color: ${themeGetColor('blue.200')};
      border-color: ${themeGetColor('blue.300')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGetColor('blue.100', 0.5)};
    }
  }
`;
export function getFilterButtonAppearance(appearance) {
    switch (appearance) {
        case 'draft':
            return draftStyle;
        case 'default':
        default:
            return defaultStyle;
    }
}
